import { render, staticRenderFns } from "./WhatWeAchieved.vue?vue&type=template&id=898002b2&"
import script from "./WhatWeAchieved.vue?vue&type=script&lang=ts&"
export * from "./WhatWeAchieved.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports